import { TextField } from "../../../../utils/form";

const LicenseNumber = ({ form: { control }, ...props }) =>
  <TextField control={control} name="licenseNumber" label="Nº de matrícula" variant="outlined" required helperText="Sin puntos ni comas" style={{ width: "100%" }} {...props} />

export default LicenseNumber;